<template>
  <div class="dialog_wrap"  :class="isMobile?'pop_mobile':'pop_pc'" @click="closeDialog">
    <div class="dialog_wrap_long" @click.stop="noTouch">
      <div class="dialog_wrap_close" @click="closeDialog"></div>
      <div class="dialog_wrap_content" v-if="!isShowAdress">
        <div class="wrap_content_title">奖励记录</div>
        <div class="wrap_content_desc">
          <ul class="wrap_content_ul">
            <div class="award-tip" v-if="!list">{{ tip }}</div>
            <li class="wrap_content_li" v-for="(item,index) in list" v-bind:key="'li-'+index" v-else>
              <div class="award-code-wrap">
                <span class="award-code" v-if="item.award_id>6">{{ item.award_id | awardName }}:{{item.code}}</span>
                <span class="award-code" v-else>{{item.award_id | awardName }}</span>
              </div>
              <div class="award-copy"  @click="doCopy(item.code)" v-if="item.award_id>6">复制</div>
              <div class="award-copy"  @click="dressDialog(item)" v-else>填写地址</div>
            </li>
          </ul>
          <div class="award-tip">{{ tip }}</div>
        </div>
      </div>

      <div class="dialog_wrap_content" v-else>>
        <div class="wrap_content_title">收件地址</div>
        <div class="wrap_content_desc">
          <div class="form-input">
            <img :src="staticUrl+'office/xzdzm/reservation/user.png'" alt class="icon-input">
            <input class="mobile-input" placeholder="请填写收件人姓名" v-model.trim="userName" />
          </div>
          <div class="form-input">
            <img :src="staticUrl+'office/xzdzm/reservation/mobile.png'" alt class="icon-input">
            <input class="mobile-input" type="tel" @input="inputNumeric"  placeholder="请填写手机号码" v-model.trim="mobileNum" />
          </div>
          <div class="form-textarea">
            <textarea class="mobile-textarea" placeholder="请填写详细地址：省、市、区、街道以及详细地址(小区楼栋/乡村名称)" v-model.trim="userAdress" />
          </div>
          <div class="login-checkbox">
            注意：请掌门认真核查邮寄地址与个人信息，由于信息输入错误导致周边无法放发或发放错误的，将不予补发
          </div>
        </div>
        <div class="wrap_content_btns">
          <div class="btn-ok" @click="tickAdress">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AwardList',
  computed: {
    ...mapGetters(['isMobile', 'awards','staticUrl'])
  },
  data () {
    return {
      list: [],
      tip: '游戏礼包有效期截止至公测后30天以内',
      isShowAdress: false,
      mobileNum: '',
      userName: '',
      userAdress: ''
    }
  },
  mounted () {
    document.getElementsByTagName('body')[0].classList.add('noscroll');
    this.getAwardList();
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('noscroll');
  },
  watch: {
    mobileNum (value) {
      if (value.length > 0) {
        this.mobileNum = value.replace(/[^0-9]/, '')
        this.mobileNum = value.substr(0, 11)
      }
    }
  },
  methods: {
    ...mapActions(['ActCodeList','ActSaveAddress']),
    noTouch () {

    },
    closeDialog () {
      this.$emit('onClose', true)
      this.$router.push({ name: 'reservation', query: this.$route.query })
    },
    inputNumeric (e) {
      this.mobileNum = e.target.value.replace(/\D/, '')
    },
    getAwardList () {
      this.ActCodeList().then(res => {
        this.list = res.list
        if (res.code === 1) {
          this.tip = res.msg
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    doCopy: function (val) {
      let that = this
      this.$copyText(val).then(function (e) {
        that.showSuccess('复制成功');
      }, function (e) {
        that.showSuccess('复制失敗');
      })
    },
    dressDialog (val) {
      this.isShowAdress = true
      console.log(val)
    },
    tickAdress () {
      if (this.userName.length < 2) {
        this.showError('请输入正确的写收件人姓名')
        return;
      }
      if (this.mobileNum.length !== 11) {
        this.showError('请输入正确的手机号码')
        return;
      }
      if (this.userAdress.length < 12) {
        this.showError('请输入正确的详细地址')
        return;
      }
      this.ActSaveAddress({ name: this.userName, mobile: this.mobileNum, address: this.userAdress }).then(res => {
        if (res.code === 1) {
          this.showError(res.msg)
          return
        }
        this.isShowAdress = false
        this.showSuccess('收件地址已经成功提交！')
      }).catch((err) => {
        console.log(err)
      })
      console.log(this.userName)
    }
  }
}
</script>

<style lang="scss">

</style>
